import React, { useEffect, useState } from 'react';
import { Spinner, Modal } from 'react-bootstrap';
import Lottie from 'lottie-react';
import loadingTelescope from '../../icons/loadingTelescope.json';
import './loading-spinner.css';

interface LoadingSpinnerProps {
  show: boolean;
  message?: string;
  minDuration?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  show,
  message,
  minDuration = 1000000,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (show) {
      setIsVisible(true);
      timeout = setTimeout(() => {
        setIsVisible(false);
      }, minDuration);
    } else {
      timeout = setTimeout(() => setIsVisible(false), minDuration);
    }
    return () => clearTimeout(timeout);
  }, [show, minDuration]);

  if (!isVisible) return null;

  return (
    <div className="loading-spinner-overlay">
      <div className="loading-content">
        <Lottie animationData={loadingTelescope} loop className="loading-animation" />
        <p className="loading-text">{message || 'Loading....'} </p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
